export default __webpack_public_path__ + "static/media/brand_master.ac64dd4e.svg";